import React from 'react';
import styled from 'styled-components';
import { useTenant } from 'tenants/TenantProvider';

type ImgProps = {
  $width?: string;
  alt?: string;
  className?: string;
};

const StyledLogo = styled.img<ImgProps>`
  width: ${(props) => props.$width || '120px'};
`;

const Logo = ({ $width, alt, className }: ImgProps) => {
  const { branding } = useTenant();

  return React.createElement(StyledLogo, {
    $width,
    alt: alt || `${branding.appName} logo`,
    className,
    src: branding.logoUrl,
  });
};

export default Logo;
